var define = undefined;
var $ = require('jquery');
var vue = require('vue');

function setMeta(name, content) {
  const selector = `meta[property="${name}"]`;
  if ($(selector).length) {
    $(selector).attr('content', content)
  } else {
    $('head').append(`<meta property="${name}" content="${content}">`)
  }
}

var BlogArticle = vue.extend({
    template: false,
    data() {
        return {
            encodedCompanyId: '',
            notFound: false,
            article: {
                title: '',
                content: '',
                featuredImage: '',
                publishedTimestamp: '',
                fake: true
            }
        };
    },
    computed: {
        showArticle() {
            return !this.article.fake;
        }
    },
    methods: {
        loadedArticle(data) {
            if (data.success === false) {
                return this.failedToLoadArticle();
            }

            this.article = data.article;

            this.setMetadata();
        },
        failedToLoadArticle() {
            console.log('failed to load articles', arguments);
            this.notFound = true;
        },
        setMetadata() {
          const {
            title,
            shortDescription,
            featuredImage
          } = this.article;

          document.title = title;

          const metadata = {
            title,
            description: shortDescription,
            'twitter:card': 'summary',
            'twitter:description': shortDescription,
            'twitter:image': featuredImage,
            'og:type': 'article',
            'og:title': title,
            'og:description': shortDescription,
            'og:image': featuredImage
          };

          for (var key in metadata) {
            setMeta(key, metadata[key]);
          }
        }
    },
    ready() {
      const ssid = this.encodedCompanyId;
      $.ajax({
          method: 'GET',
          dataType: 'json',
          url: `${this.baseUrl}/prospector/getBlogArticle/${ssid}/${this.slug}`,
          success: this.loadedArticle.bind(this),
          error: this.failedToLoadArticle.bind(this)
      });
    }
});

module.exports = BlogArticle;



// WEBPACK FOOTER //
// ./src/js/blog/article.js